import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';

import { BillingPlanIds } from '../../../../enums/billing-plan-ids';
import Global from '../../../../store/global-selectors';

const CANCELLED_CUTOFF_MONTHS = 6;

type SubscriptionPlanInfo = {
  billingPlanId?: string | number;
  isExpired?: boolean | null;
};

type PlanInfo = {
  cancelledDateTimeUTC?: string | null;
  isCanceled?: boolean | null;
  isTrialExpired?: boolean | null;
};

type SubscriptionData = {
  defaultProfilePlans?: unknown[] | null;
};

export const useShouldForceNewestPlans = (): boolean => {
  const subscriptionData: SubscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const subscriptionPlanInfo: SubscriptionPlanInfo = useSelector(Global.selectSellerSubscriptionPlanInfo);
  const planInfo: PlanInfo = useSelector(Global.selectSellerPlanInfo);

  return useMemo(() => {
    const defaultProfilePlans = subscriptionData?.defaultProfilePlans;
    if (!defaultProfilePlans || defaultProfilePlans.length === 0) {
      return false;
    }

    const isTrialBillingPlan = subscriptionPlanInfo?.billingPlanId?.toString() === BillingPlanIds.Trial.toString();
    const isInactiveTrial =
      isTrialBillingPlan &&
      (subscriptionPlanInfo?.isExpired === true || planInfo?.isTrialExpired === true || planInfo?.isCanceled === true);
    if (isInactiveTrial) {
      return true;
    }

    if (planInfo?.isCanceled !== true || !planInfo?.cancelledDateTimeUTC) {
      return false;
    }

    const cancelledAt = DateTime.fromISO(planInfo.cancelledDateTimeUTC);
    if (!cancelledAt.isValid) {
      return false;
    }

    const cutoff = DateTime.now().minus({ months: CANCELLED_CUTOFF_MONTHS });
    return cancelledAt < cutoff;
  }, [subscriptionData, subscriptionPlanInfo, planInfo]);
};
